@if (imageSrc) {
    <div class="image-container-zoom">
        <div class="backdrop-div" (click)="close()"></div>
        <img [src]="imageSrc" alt="image" class="img-fluid" />
        <button id="close-button" type="button" (click)="close();" aria-hidden="true">
            <i-feather name="x"></i-feather>
        </button>
    </div>
}
